import { defineComponent as _defineComponent } from 'vue';
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "!overflow-visible",
    "data-archive-events-posts": ""
};
const _hoisted_2 = { class: "flex flex-col gap-10 lg:gap-20" };
const _hoisted_3 = {
    key: 0,
    class: "container"
};
const _hoisted_4 = { class: "wysiwyg w-full lg:w-2/3" };
const _hoisted_5 = { class: "container" };
const _hoisted_6 = {
    key: 1,
    class: "grid-layout container -mt-5 lg:-mt-14"
};
const _hoisted_7 = {
    key: 2,
    class: "container text-center"
};
const _hoisted_8 = {
    key: 3,
    class: "grid-layout container"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { "data-quicklinks": "" };
import { computed, defineAsyncComponent, onMounted } from 'vue';
import PostsFilter from '@molecules/PostsFilter.vue';
import FeaturedPosts from '@molecules/FeaturedPosts.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArchiveWhatsOn',
    props: {
        intro: {},
        quickLinksSections: {},
        posts: {},
        pagination: {},
        filterOptions: {},
        pastEvents: {},
        virtualEvents: {},
        eventsSeries: {},
        eventSeriesTitle: {}
    },
    setup(__props) {
        const QuickLinks = defineAsyncComponent(() => import('@molecules/QuickLinks.vue'));
        const SignpostsBlock = defineAsyncComponent(() => import('@blocks/SignpostsBlock.vue'));
        const EventSignpostBlock = defineAsyncComponent(() => import('@organisms/EventSignpostBlock.vue'));
        const PostCard = defineAsyncComponent(() => import('@atoms/PostCard.vue'));
        const ArchivePagination = defineAsyncComponent(() => import('@molecules/ArchivePagination.vue'));
        const props = __props;
        const pastEventsData = computed(() => {
            const posts = [];
            posts.push({
                title: props.pastEvents.title,
                url: '/archive/past-events/',
                image: props.pastEvents.image,
            });
            return posts;
        });
        const hasVirtualEvents = computed(() => {
            return props.virtualEvents && Object.keys(props.virtualEvents).length > 0;
        });
        const hasEventsSeries = computed(() => {
            return (props.eventsSeries &&
                Object.keys(props.eventsSeries).length > 0 &&
                currentPage.value == 1);
        });
        const displayPagination = computed(() => {
            return (props.pagination &&
                Object.keys(props.pagination.pages).length > 1 &&
                Object.keys(props.posts).length > 0);
        });
        //check what page we are on based on url eg /page/2
        const currentPage = computed(() => {
            const url = window.location.href;
            const page = url.match(/\/page\/\d+/g);
            if (page) {
                // Use parseInt to convert the matched string to a number
                return parseInt(page[0].replace('/page/', ''), 10);
            }
            // If no match is found, default to 1
            return 1;
        });
        const hasPosts = computed(() => {
            return Object.keys(props.posts).length > 0;
        });
        const firstThreePosts = computed(() => {
            if (currentPage.value > 1) {
                return [];
            }
            return props.posts.slice(0, 3);
        });
        const hasFirstThreePosts = computed(() => {
            return Object.keys(firstThreePosts.value).length > 0;
        });
        const remainingPosts = computed(() => {
            if (currentPage.value > 1) {
                return props.posts;
            }
            return props.posts.slice(3);
        });
        const hasRemainingPosts = computed(() => {
            return Object.keys(remainingPosts.value).length > 0;
        });
        const scrollToContentAfterFilter = () => {
            const content = document.querySelector('[data-archive-events-posts]');
            setTimeout(() => {
                content.scrollIntoView({ behavior: 'smooth' });
            }, 300);
        };
        onMounted(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const filteredContent = urlParams.get('filtered');
            const dateSelected = urlParams.get('date');
            if (filteredContent || dateSelected) {
                scrollToContentAfterFilter();
            }
        });
        return (_ctx, _cache) => {
            const _directive_dompurify_html = _resolveDirective("dompurify-html");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (__props.intro)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
                                    [_directive_dompurify_html, __props.intro]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(PostsFilter, { "filter-options": __props.filterOptions }, null, 8, ["filter-options"])
                        ]),
                        (hasFirstThreePosts.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstThreePosts.value, (post) => {
                                    return (_openBlock(), _createBlock(_unref(PostCard), {
                                        post: post,
                                        class: "!opacity-100"
                                    }, null, 8, ["post"]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true),
                        (!hasPosts.value)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_7, " Sorry, there are no posts to display for your filter selection. Please try another. "))
                            : _createCommentVNode("", true),
                        (hasRemainingPosts.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remainingPosts.value, (post) => {
                                    return (_openBlock(), _createBlock(_unref(PostCard), {
                                        post: post,
                                        class: "!opacity-100"
                                    }, null, 8, ["post"]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true),
                        (displayPagination.value)
                            ? (_openBlock(), _createBlock(_unref(ArchivePagination), {
                                key: 4,
                                class: "container",
                                pagination: __props.pagination
                            }, null, 8, ["pagination"]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (hasVirtualEvents.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                        (hasEventsSeries.value)
                            ? (_openBlock(), _createBlock(_unref(EventSignpostBlock), {
                                key: 0,
                                posts: __props.eventsSeries,
                                title: __props.eventSeriesTitle || 'Our Event Series',
                                class: "bg-green-50"
                            }, null, 8, ["posts", "title"]))
                            : _createCommentVNode("", true),
                        _createVNode(FeaturedPosts, {
                            "featured-posts": __props.virtualEvents,
                            title: "Virtual Exhibitions"
                        }, null, 8, ["featured-posts"])
                    ]))
                    : _createCommentVNode("", true),
                (__props.pastEvents)
                    ? (_openBlock(), _createBlock(_unref(SignpostsBlock), {
                        key: 1,
                        posts: pastEventsData.value,
                        title: __props.pastEvents.title,
                        paragraph: __props.pastEvents.paragraph,
                        colorClasses: "bg-green-50"
                    }, null, 8, ["posts", "title", "paragraph"]))
                    : _createCommentVNode("", true),
                (__props.quickLinksSections)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(__props.quickLinksSections, (quickLinks) => {
                        return (_openBlock(), _createElementBlock("section", _hoisted_10, [
                            _createVNode(_unref(QuickLinks), { quickLinks: quickLinks }, null, 8, ["quickLinks"])
                        ]));
                    }), 256))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
